import { render } from "./Competitionlist.vue?vue&type=template&id=58c12a92&ts=true"
import script from "./Competitionlist.vue?vue&type=script&lang=ts"
export * from "./Competitionlist.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__